import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

const initialState = {
    status: 'idle',
    sidebarlist: [],
    error: '',
}

export const sidebarTags = createAsyncThunk(
    'sidebar/sidebarTags',
    async (values) => {
        const res = await axios.post(`${process.env.REACT_APP_BASE_URL}/api/allproducts-tags`, values)
        //console.log(res.data)
        return res.data.data
    }
)


export const sidebarSlice = createSlice({
    name:'sidebar',
    initialState,
    reducers: {

    },
    extraReducers: (builder) => {
        builder
        .addCase(sidebarTags.pending, (state) => {
            state.status = 'loading'
            state.error = ''
        })
        .addCase(sidebarTags.fulfilled, (state, action) => {
            state.status = "true"
            state.error = ''
            state.sidebarlist = action.payload
        })
        .addCase(sidebarTags.rejected, (state, action) => {
            state.status = "false"
            state.sidebarlist = []
            state.error = action.error.message
        })
        
    }
})

export const sidebarresultlist = (state) => state.sidebar.sidebarlist
export default sidebarSlice.reducer